import { __assign } from "tslib";
import React from 'react';
import { Helmet } from 'react-helmet-async';
import ErrorBoundary from '../../../ErrorBoundary';
import ContentShadow from '../_partials/ContentShadow';
import { VideoPlayer } from '../../../VideoPlayer/LoadableVideoPlayer';
import DeviationMediaService from '../../../utils/DeviationMediaService';
import { getSource } from '../../_helpers';
import useDeviationDrag from '../../../Dnd/useDeviationDrag';
import s from './Film.scss';
export var FilmFullView = function (_a) {
    var deviation = _a.deviation, height = _a.height, width = _a.width;
    var _b = useDeviationDrag({
        deviation: deviation,
        width: 400,
        height: 400,
    }), dragPreview = _b.dragPreview, drag = _b.drag;
    var videoFile = getSource(DeviationMediaService.getMediaByType(deviation, 'video'));
    if (!videoFile) {
        return null;
    }
    var previewFile = DeviationMediaService.getDeviationFile(deviation, 'preview');
    return (React.createElement(ErrorBoundary, { debugComponent: "FillFullView" },
        React.createElement(Helmet, null,
            previewFile && (React.createElement("link", { rel: "preload", href: previewFile.src, as: "image" })),
            React.createElement("link", { rel: "preload", href: videoFile.src, as: "video" })),
        React.createElement("div", { className: s['root'], style: { width: width, height: height } },
            React.createElement("div", { ref: drag },
                React.createElement(ContentShadow, { content: __assign(__assign({}, videoFile), { width: width, height: height }), containerSize: { width: width, height: height } },
                    React.createElement(VideoPlayer, { width: width, height: height, src: videoFile.src, loadingCover: previewFile && previewFile.src, autoPlay: false })))),
        dragPreview));
};
FilmFullView.displayName = 'FilmFullView';
export default FilmFullView;
//# sourceMappingURL=Film.js.map